import state from './moduleCouponManagementState.js'
import mutations from './moduleCouponManagementMutations.js'
import actions from './moduleCouponManagementActions.js'
import getters from './moduleCouponManagementGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters

}

